import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import '../../styles/global.css';

interface ActiveItem {
  item_id: number;
  material: string | null;
  srednica: string | null;
  waga: string | null;
  kolor: string | null;
  barwnik: string | null;
  nazwa_oryg: string | null;
  assignment_id: number;
  previous_user_id: number | null;
  previous_user_name: string | null;
  started_at: string | null;
}

interface ContinueActiveItemModalProps {
  activeItem: ActiveItem;
  onContinue: () => void;
  onCancel: () => void;
}

const ContinueActiveItemModal: React.FC<ContinueActiveItemModalProps> = ({
  activeItem,
  onContinue,
  onCancel,
}) => {
  const { t } = useLanguage();

  const getItemName = () => {
    const parts = [];
    if (activeItem.material) parts.push(activeItem.material);
    if (activeItem.srednica) parts.push(`Ø${activeItem.srednica}`);
    if (activeItem.waga) parts.push(`${activeItem.waga}g`);
    if (activeItem.kolor) parts.push(activeItem.kolor);
    if (activeItem.barwnik) parts.push(activeItem.barwnik);
    if (activeItem.nazwa_oryg) parts.push(activeItem.nazwa_oryg);
    
    return parts.length > 0 ? parts.join(' / ') : t('activeItem.unknownItem');
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '30px',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
        }}
      >
        <h2 style={{ marginTop: 0, marginBottom: '20px', color: '#667eea', textAlign: 'center' }}>
          ⚠️ {t('activeItem.activeItemTitle')}
        </h2>
        
        <div
          style={{
            backgroundColor: '#fff3cd',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '20px',
            border: '2px solid #ffc107',
          }}
        >
          <div style={{ marginBottom: '10px', fontWeight: '600', color: '#856404' }}>
            {t('activeItem.activeItemFound')}
          </div>
          <div style={{ fontSize: '16px', color: '#856404', marginBottom: '10px' }}>
            <strong>{getItemName()}</strong>
          </div>
          {activeItem.previous_user_name && (
            <div style={{ fontSize: '14px', color: '#856404' }}>
              {t('activeItem.previousOperator')}: <strong>{activeItem.previous_user_name}</strong>
            </div>
          )}
        </div>

        <div style={{ marginBottom: '25px', textAlign: 'center', fontSize: '16px', color: '#4a5568' }}>
          <strong>{t('activeItem.continueTitle')}</strong>
        </div>

        <div style={{ display: 'flex', gap: '15px' }}>
          <button
            onClick={onContinue}
            className="btn btn-primary"
            style={{
              flex: 1,
              padding: '14px',
              fontSize: '16px',
              fontWeight: '600',
            }}
          >
            ✅ {t('common.yes')}
          </button>
          <button
            onClick={onCancel}
            className="btn btn-outline"
            style={{
              flex: 1,
              padding: '14px',
              fontSize: '16px',
              fontWeight: '600',
            }}
          >
            ❌ {t('common.no')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContinueActiveItemModal;











